import React from 'react';
import { Typography, TypographyOwnProps } from '@mui/material';
import { FormattedTextField, TextField } from 'framework/ui/field';
import InfoRow from './InfoRow';
import InfoCard from './InfoCard';

const getCPIColor = (value: number): TypographyOwnProps['color'] => {
  if (value < 0.97) return 'error';
  if (value > 1.03) return 'success';
  return 'warning';
};

const ProjectTimeline: React.FC = () => {
  return (
    <InfoCard title="Project timeline">
      <InfoRow label="Timeline total/used, bdays">
        <FormattedTextField
          label=""
          source="projectTimeline"
          format={(str: any) =>
            !str ? '—' : `${str?.timelineTotalBdays} / ${str?.timelineUsedBdays} (${str?.timelineUsedPercentage}%)`
          }
        />
      </InfoRow>

      <InfoRow label="Timeline remaining, bdays">
        <TextField label="" source="projectTimeline.timelineRemainingBdays" />
      </InfoRow>

      <InfoRow label="CPI, timeline">
        <FormattedTextField
          label=""
          source="projectTimeline.cpiTimeline"
          format={(str: string) => <Typography color={getCPIColor(Number(str))}>{str || '—'}</Typography>}
        />
      </InfoRow>

      <InfoRow label="CPI timeline projection, bdays" isLast>
        <TextField label="" source="projectTimeline.cpiTimelineProjectionBdays" />
      </InfoRow>
    </InfoCard>
  );
};

export default ProjectTimeline;
